module.exports = __webpack_public_path__ + "img/logo-light.876dd34d.png";